/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */
/* eslint-disable prefer-const */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-return-assign */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
import * as THREE from 'three';
import React, {
  Suspense,
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react';

import { Canvas, useFrame, useLoader } from '@react-three/fiber';
import { OrbitControls, Stats } from '@react-three/drei';
import './example-container.scss';

import texture from '../../assets/default-texture.png';
import texture2 from '../../assets/default-texture-2.jpg';

type WebGLContainerType = {} & typeof defaultProps;
const defaultProps = {};

const WebGLContainer = (props: WebGLContainerType) => {
  const [tx, setTx] = useState(texture);

  const selectTx = (texture: any) => {
    console.log(texture);
    setTx(texture);
  };

  const Sphere = (props: JSX.IntrinsicElements['mesh']) => {
    const sphereRef: any = useRef();
    const repeatX = 1;
    const repeatY = 1;

    const base = useLoader(THREE.TextureLoader, tx);
    base.wrapS = THREE.RepeatWrapping;
    base.wrapT = THREE.RepeatWrapping;
    base.repeat.set(repeatX, repeatY);

    useFrame(() => {
      sphereRef.current.rotation.x += 0.01;
      sphereRef.current.rotation.y += 0.01;
    });
    return (
      <mesh ref={sphereRef}>
        <sphereGeometry args={[3, 40, 40]} />
        <meshPhysicalMaterial
          map={base}
        />
      </mesh>
    );
  };

  return (
    <div className="example-container">
      <ul>
        <li onClick={() => selectTx(texture)}>1</li>
        <li onClick={() => selectTx(texture2)}>2</li>
      </ul>
      <Canvas style={{ height: 450, width: 450 }}>
        <ambientLight intensity={1} />
        <Suspense fallback={null}>
          <Sphere />
        </Suspense>
        <OrbitControls
          dampingFactor={0.01}
        />
      </Canvas>
    </div>
  );
};

WebGLContainer.defaultProps = defaultProps;

export default WebGLContainer;
